// Vendor Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {isEmpty, isArray} from 'lodash';
import {Link, withRouter} from 'react-router-dom';

// PrimeReact UI components
import {Card} from 'primereact/card';
import {Dialog} from 'primereact/dialog';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {ScrollPanel} from 'primereact/scrollpanel';
import {Button} from 'primereact/button';

// Components
import Thumbnail from '../components-core/thumbnail';
import Loading from '../components-core/loading';
import searchHoc from './search-wrapper';

// Images
import seeMore from './SeeMore.png';

const servicesDataKey = 'loadSubShelvesResults';

const styles = {
    shelfObj: {width: '100%', overflowX: 'auto', whiteSpace: 'nowrap'},
    dialog: {height: 'auto', width: '90%', maxHeight: '95%', overflow: 'auto'},
    scrollPanel: {width: 'auto', height: 'auto', display: 'flex'},
    table: {margin: '10px 0px -25px 10px'},
    column1: {width: '30%'},
};
class ShelfItemThumbnails extends Component {
    state = {
        visible: false,
        dialogType: undefined,
        data: undefined,
        ready: false,
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {searchData} = this.props;

        if (searchData != nextProps.searchData) {
            this.setState({ready: true});
        }
    }

    getClass() {
        const {className} = this.props;
        return classnames(className, 'shelf-nav');
    }

    handleClick = data => {
        const options = [];
        let metadataType = 'Asset';

        if (data.class.includes('AssetPreviewDTO')) {
            options.push({key: 'Class', value: data.class});
            options.push({key: 'Asset Name', value: data.name});
            options.push({key: 'Id', value: data.id});
            options.push({key: 'Description', value: data.description});
            options.push({key: 'Release Year', value: data.year});
            options.push({key: 'Category', value: data.category});
            options.push({key: 'Duration', value: data.duration});
            options.push({key: 'MPAA Rating', value: data.mpaaRating});
            options.push({key: 'Star Rating', value: data.starRating});
            options.push({key: 'Best Resolution', value: data.bestResolution});
            options.push({key: 'Closed Captioned', value: data.closedCaptioned});
            options.push({key: 'Extra Params', value: data.extraParams});
            options.push({key: 'echostar3Id', value: data.echostar3Id});
            options.push({key: 'echoId', value: data.echoId});
            options.push({key: 'Title', value: data.title});
            let actorsStr = '';
            if (data.actors) {
                for (let a = 0; a != data.actors.length; a++) {
                    actorsStr = actorsStr.concat(`${data.actors[a]}, `);
                }
                options.push({key: 'Actors', value: actorsStr});
            }
        } else if (data.class.includes('SeriesDTO')) {
            metadataType = 'Series';
            options.push({key: 'Class', value: data.class});
            options.push({key: 'Series Name', value: data.name});
            options.push({key: 'Id', value: data.id});
            options.push({key: 'Description', value: data.description});
            options.push({key: 'Duration', value: data.duration});
            options.push({key: 'Extra Params', value: data.extraParams});
            options.push({key: 'echostar3Id', value: data.echostar3Id});
            options.push({key: 'echoId', value: data.echoId});
        } else if (data.class.includes('NetworkDTO')) {
            metadataType = 'Network';
            options.push({key: 'Class', value: data.class});
            options.push({key: 'Name', value: data.name});
            options.push({key: 'Display Name', value: data.displayName});
            options.push({key: 'Id', value: data.id});
        } else if (data.class.includes('FolderDTO')) {
            metadataType = 'Folder';
            options.push({key: 'Class', value: data.class});
            options.push({key: 'Folder Name', value: data.name});
            options.push({key: 'Id', value: data.id});
            options.push({key: 'Late Night', value: data.lateNight});
            options.push({key: 'Only Contains Episodes', value: data.onlyContainsEpisodes});
            options.push({key: 'Resource Type', value: data.resourceType});
            options.push({key: 'Extra Params', value: data.extraParams});
        } else if (data.class.includes('SeeMoreDTO')) {
            metadataType = 'SeeMore';
            options.push({key: 'Class', value: data.class});
            options.push({key: 'Name', value: data.name});
            options.push({key: 'Id', value: data.id});
            options.push({key: 'Late Night', value: data.lateNight.toString()});
        } else if (data.class.includes('SeeAllDTO')) {
            metadataType = 'SeeAll';
            options.push({key: 'Class', value: data.class});
            options.push({key: 'Id', value: data.id});
            options.push({key: 'Name', value: data.name});
        } else {
            options.push({key: 'Asset Class', value: data.class});
            options.push({key: 'Asset Name', value: data.name});
            options.push({key: 'Id', value: data.id});
        }

        this.setState({visible: true, data: options, dialogType: metadataType});
    };

    renderShelves() {
        const {error, matchUrl, parentId, shelfWebObj, searchData, className, history} = this.props;
        const shelves = [];

        if (!error && !isEmpty(shelfWebObj)) {
            // ForEach subShelf
            for (let subShelfIdx = 0; subShelfIdx < shelfWebObj.length; subShelfIdx++) {
                // Append subShelf id's to subShelfUrl for breadcrumb support
                let subShelfUrl = '';
                if (matchUrl) {
                    subShelfUrl = `${matchUrl}/`;
                } else {
                    subShelfUrl = '/sub-shelves/';
                }
                subShelfUrl += shelfWebObj[subShelfIdx].ShelfDTO.id;

                const shelfEditUrl = `/edit-shelf/${parentId}/${shelfWebObj[subShelfIdx].ShelfDTO.id}`;

                const titleLink = <Link to={subShelfUrl}>{shelfWebObj[subShelfIdx].ShelfDTO.name}</Link>;

                const footer = (
                    <span>
                        <Button
                            className="p-button-outlined p-button-secondary"
                            label="Edit"
                            onClick={() => history.push(shelfEditUrl)}
                        />
                    </span>
                );

                let stbResults;
                let totalResults = 0;
                if (searchData.shelves != null && isArray(searchData.shelves)) {
                    const stbSubShelfIdx = searchData.shelves.findIndex(
                        stbShelf => stbShelf.id == shelfWebObj[subShelfIdx].ShelfDTO.id
                    );

                    if (stbSubShelfIdx >= 0) {
                        stbResults = this.renderShelfDetail(stbSubShelfIdx);
                        totalResults = searchData.shelves[stbSubShelfIdx].totalResults;
                    }
                }

                shelves.push(
                    <Card
                        footer={footer}
                        key={subShelfIdx}
                        subTitle={`${totalResults} matches for ${shelfWebObj[subShelfIdx].ShelfDTO.name}`}
                        title={titleLink}
                    >
                        {stbResults}
                    </Card>
                );
            }
        }

        return shelves.length ? (
            <div className={classnames('shelfitem-detail--thumbnail-group', className)}>{shelves}</div>
        ) : null;
    }

    renderShelfDetail(shelfId) {
        const shelfObj = [];
        const {searchData} = this.props;
        let shelfContent = <p />;

        if (searchData.shelves != null && !isEmpty(searchData.shelves)) {
            shelfContent = this.renderShelfResults(shelfId);
        } else {
            shelfContent = <p>Loading shelf results</p>;
        }

        shelfObj.push(
            <div className="renderedShelves" key={shelfId} style={styles.shelfObj}>
                {shelfContent}
            </div>
        );

        return shelfObj;
    }

    renderShelfResults(subShelfIdx) {
        const {searchData} = this.props;
        let SeeMoreDtoCount = 0;
        const thumbnailObj = [];

        // For each ResultDTO returned from the Catalog
        if (searchData.shelves != null && isArray(searchData.shelves)) {
            if (searchData.shelves[subShelfIdx] != null) {
                for (let c = 0; c < searchData.shelves[subShelfIdx].items.length; c++) {
                    let url = seeMore;
                    let tooltip = '';

                    if (searchData.shelves[subShelfIdx].items[c].class.includes('SeeMoreDTO')) {
                        SeeMoreDtoCount++;
                    } else if (!isEmpty(searchData.shelves[subShelfIdx].items[c].images)) {
                        for (let gfx = 0; gfx < searchData.shelves[subShelfIdx].items[c].images.length; gfx++) {
                            if (
                                searchData.shelves[subShelfIdx].items[c].images[gfx].url.includes('jpeg') ||
                                searchData.shelves[subShelfIdx].items[c].images[gfx].url.includes('jpg') ||
                                searchData.shelves[subShelfIdx].items[c].images[gfx].url.includes('png')
                            ) {
                                url = searchData.shelves[subShelfIdx].items[c].images[gfx].url;
                                tooltip =
                                    searchData.shelves[subShelfIdx].items[c].class +
                                    ' - ' +
                                    searchData.shelves[subShelfIdx].items[c].name;
                                break;
                            }
                        }
                    }

                    let label = searchData.shelves[subShelfIdx].items[c].name;

                    // Trim thumbnail label to 15 chars
                    if (label.length >= 16) {
                        label = label.substr(0, 14);
                    }

                    if (url) {
                        thumbnailObj.push(
                            <Thumbnail
                                altText={tooltip}
                                className="adv-detail--thumbnail"
                                data={searchData.shelves[subShelfIdx].items[c]}
                                height={128}
                                imgSrc={url}
                                key={c}
                                label={label}
                                maxWidth={128}
                                width={128}
                                onClick={this.handleClick}
                            />
                        );
                    }
                }
            }
        }

        return thumbnailObj;
    }

    render() {
        const {fetching, searchData} = this.props;
        const {visible, dialogType, data} = this.state;
        const {ready} = this.state;

        const editShelf = [];
        if (ready && isArray(searchData.shelves)) {
            editShelf.push(
                <div className="shelfitem-thumbnails" key="editShelf">
                    <Loading
                        className="thumbnail--loading"
                        loading={fetching}
                        progressText="Loading thumbnails..."
                        small={true}
                    />
                    {this.renderShelves()}

                    <Dialog
                        className="shelfDialog"
                        dismissableMask={false}
                        header={`${dialogType} Detail`}
                        maximizable={true}
                        modal={true}
                        style={styles.dialog}
                        visible={visible}
                        onHide={() => this.setState({visible: false})}
                    >
                        <ScrollPanel className="shelfitem-content" style={styles.scrollPanel}>
                            <DataTable style={styles.table} value={data}>
                                <Column field="key" header="Key" style={styles.column1} />
                                <Column field="value" header="Value" />
                            </DataTable>
                        </ScrollPanel>
                    </Dialog>
                </div>
            );
            return <div>{editShelf}</div>;
        }

        return (
            <Loading className="thumbnail--loading" loading={fetching} progressText="Loading subShelves..." small={true} />
        );
    }
}

ShelfItemThumbnails.propTypes = {
    className: PropTypes.string,
    error: PropTypes.string,
    fetching: PropTypes.bool,
    matchUrl: PropTypes.string,
    parentId: PropTypes.number,
    searchData: PropTypes.object.isRequired,
    shelfWebObj: PropTypes.array,
    history: PropTypes.object,
};

export default withRouter(searchHoc(ShelfItemThumbnails, servicesDataKey));
